import { Directive, HostBinding, OnInit, ElementRef, Input } from '@angular/core';
import { NgsRevealConfig } from '../services/ngs-reveal-config';
import { NgsRevealService } from '../services/ngs-reveal.service';
import { AbstractNgsRevealDirective } from './ngs-reveal-common.directive';

/**
 * Directive to add 'ScrollReveal' functionality to a <b>single DOM element</b> in the page.
 */

export class NgsRevealDirective extends AbstractNgsRevealDirective implements OnInit {

    
    visibility = 'hidden';

    /**
     * Custom configuration to use when revealing this element
     */
    
    set _config(value: string | NgsRevealConfig) {
        this._initConfig(value);
    }

    constructor(private elementRef: ElementRef, ngsRevealService: NgsRevealService) {
        super(ngsRevealService);
    }

    ngOnInit() {
        this.ngsRevealService.reveal(this.elementRef, this.config);
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[ngsReveal]'
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
{type: ElementRef, },
{type: NgsRevealService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'visibility': [{ type: HostBinding, args: ['style.visibility', ] },],
'_config': [{ type: Input, args: ['ngsReveal', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
